import React from 'react';
import PropTypes from 'prop-types';
import ListItem from './list-item';

const RestaurantRow = ({ restaurant, href, availability }) => {
  return (
    <ListItem
      disabled={!availability}
      to={`${href}/${restaurant.id}`}
      title={restaurant.name}
    >
      <p>{restaurant.address}, {restaurant.city}</p>
      {!availability && <div className="not-available">Ora non disponibile</div>}
    </ListItem>
  );
};

RestaurantRow.propTypes = {
  restaurant: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.string,
    city: PropTypes.string,
  }),
  availability: PropTypes.bool,
  href: PropTypes.string,
};

RestaurantRow.defaultProps = {
  availability: true,
};

export default RestaurantRow;



// WEBPACK FOOTER //
// ./src/components/restaurant-row.js